/** Pack hall phone strings (English), spread into en.ts. Hindi: pack.hi.ts. */
export const packEn = {
  'pack.devSeed': 'Load packing hall demo data',
  'pack.home.section': 'Packing hall',
  'pack.home.title': 'Pack line',
  'pack.home.hint': 'Start a pack run, fill and weigh, close',
  'pack.home.runs': 'Pack runs · {n}',
  'pack.home.none': 'No pack run planned',
  'pack.home.noneBody':
    'The office plans each pack run from a batch. Update the site list to see new ones.',
  'pack.home.closed': 'Closed runs',
  'pack.home.lotsHint': 'Pouches wait at the hall until the lot is released.',
  'pack.stage.planned': 'Planned',
  'pack.stage.filling': 'Filling',
  'pack.stage.closed': 'Closed',
  'pack.badge.batchHeld': 'Batch on hold',
  'pack.pouchesPlanned': '{n} {n:pouch|pouches} planned',
  'pack.plannedLine': '{kg} · {n} {n:pouch|pouches} planned',
  'pack.pouchesN': '{n} {n:pouch|pouches}',
  'pack.pouchesLeft': '{n} left at the hall',
  'pack.cartons': '{full} × {per} + {partial}',
  'pack.packDate': 'Packed {date}',
  'pack.bestBefore': 'Best before {date}',

  'pack.lotState.PACKING': 'Packing',
  'pack.lotState.WAITING': 'Waiting for release',
  'pack.lotState.RELEASED': 'Released',
  'pack.lotState.HELD': 'On hold',
  'pack.lotState.RECALLED': 'Recalled',
  'pack.lotState.WITHDRAWN': 'Withdrawn',
  'pack.holdReason.LAB_FAIL': 'lab result failed',
  'pack.holdReason.RUN_MIXED': 'another batch got in',
  'pack.holdReason.LABEL_MISMATCH': 'label check open',
  'pack.holdReason.QUALITY': 'quality check',

  'pack.lots.title': 'Pack lots',
  'pack.lots.hint': 'What is waiting, released or on hold',
  'pack.lots.none': 'No pack lot at this hall yet.',
  'pack.lots.readyToGo': '{n} released {n:lot has|lots have} pouches to dispatch.',
  'pack.lots.waitingHint':
    'Keep the cartons in the quarantine area. Nothing leaves until the quality person releases the lot.',
  'pack.lots.heldHint': 'On hold: put an “On hold” sign on its cartons. It cannot be dispatched.',
  'pack.lots.recalledHint': 'Recalled: do not move or sell. The office is calling the buyers.',

  'pack.run.title': 'Pack run',
  'pack.run.missing': 'This pack run is not on the phone',
  'pack.run.heldTitle': 'Batch put on hold',
  'pack.run.heldBodyStarted':
    'Stop filling and close the run with what was filled. The pouches stay in the held lot.',
  'pack.run.heldBodyNotStarted': 'This run cannot start while the batch is on hold.',

  // start
  'pack.start.licence': 'Hall licence',
  'pack.start.licenceBad':
    'The hall’s licence is missing or expired. The run cannot start; ask the office to update it.',
  'pack.start.lastCrop': 'Last run on this line',
  'pack.start.lastCropUnknown': 'Not known',
  'pack.start.allergen': 'Full allergen clean done',
  'pack.start.allergenHint': 'The last run on this line was another crop.',
  'pack.start.cleanout': 'Line and hopper empty and clean',
  'pack.start.photo': 'Photo of the empty hopper',
  'pack.start.leftover': 'Left from the last run (kg)',
  'pack.start.leftoverHint':
    'Type 0 if none. Anything found is weighed, kept aside in an ordinary sack and never packed.',
  'pack.start.scaleTitle': 'Scale check',
  'pack.start.scaleOverdue': 'calibration due',
  'pack.start.checkReading': 'Check weight reading (g)',
  'pack.start.checkHint': 'Put the {ref} g weight on the scale; allowed error {tol} g.',
  'pack.start.checkOff': 'Reading is off. Check again, or use another scale.',
  'pack.start.label': 'Label version on the roll',
  'pack.start.noLabel': 'No approved label for this product at this hall.',
  'pack.start.labelMatches': 'The roll matches these lines',
  'pack.start.labelWrong': 'Wrong roll on the line: fit the right roll before starting.',
  'pack.start.button': 'Start run',
  'pack.start.done': 'Pack lot {code} created',
  'pack.start.failed': 'The run did not start',
  'pack.start.needsNetwork':
    'Starting a run needs network: the pack lot code comes from the office.',
  'pack.label.mrp': 'MRP',
  'pack.label.net': 'Net quantity',
  'pack.label.licence': 'FSSAI licence',
  'pack.label.allergen': 'Allergen line',
  'pack.label.claim': 'Claim',

  // coder
  'pack.coder.title': 'Key into the coder',
  'pack.coder.print': 'Print',
  'pack.coder.packDate': 'Pack date',
  'pack.coder.bestBefore': 'Best before',
  'pack.coder.link': 'QR link',
  'pack.coder.hint': 'Key the lot code, dates and link exactly as shown. They never change.',

  // fill and weigh
  'pack.fill.title': 'Fill and weigh',
  'pack.fill.sacksTitle': 'Sacks into the hopper',
  'pack.fill.sacksIn': 'Sacks in',
  'pack.fill.kgIn': 'Kilos in',
  'pack.fill.scanSack': 'Sack scan',
  'pack.fill.machineWeight': 'Weight at the machine',
  'pack.fill.sackWeight': 'Sack weight (kg)',
  'pack.fill.sackIn': 'Sack in',
  'pack.fill.sackSaved': '{tag} in',
  'pack.fill.firstTitle': 'First pouch',
  'pack.fill.firstScan': 'First pouch QR',
  'pack.fill.firstPhoto': 'First pouch photo',
  'pack.fill.firstNeedsSack': 'Weigh in a sack first.',
  'pack.fill.firstOk': 'First pouch matches the lot. Filling can start.',
  'pack.fill.firstBad':
    'QR does not match the lot: stop the coder, key the lot again and print a new first pouch. Count the bad print as destroyed.',
  'pack.fill.check': 'Check pouch',
  'pack.fill.pouchMatch': 'Pouch matches the lot',
  'pack.fill.pouchMismatch': 'Pouch does not match the lot',
  'pack.fill.sackNotPouch': 'This is a sack tag, not a pouch QR',
  'pack.fill.countTitle': 'Pouches',
  'pack.fill.good': 'Pouches filled',
  'pack.fill.rejected': 'Rejected pouches',
  'pack.fill.lockedUntilFirst': 'Counting starts once the first pouch matches.',
  'pack.fill.carton': '+1 carton ({n})',
  'pack.fill.cartonLess': 'One carton less',
  'pack.fill.typeCount': 'Or type the count',
  'pack.fill.reject': '+1 rejected pouch',
  'pack.fill.lowPouch':
    'Below the minimum: empty that pouch into the hopper, refill, and count it as rejected',
  'pack.fill.spotTitle': 'Weigh pouch no. {n}',
  'pack.fill.minWeight': 'Minimum weight',
  'pack.fill.spotWeight': 'Pouch weight (g)',
  'pack.fill.belowMin': 'Below the minimum weight.',
  'pack.fill.next': 'Next',
  'pack.fill.spotsDone': '{n} {n:pouch|pouches} weighed · {low}% low',
  'pack.fill.stopLineTitle': 'Too many low pouches: stop the line',
  'pack.fill.stopLineBody': 'Call the supervisor before filling more.',
  'pack.fill.lastTitle': 'Last pouch',
  'pack.fill.lastScan': 'Last pouch QR',
  'pack.fill.lastPhoto': 'Last pouch photo',
  'pack.fill.lastOk': 'Last pouch matches the lot.',
  'pack.fill.lastBad':
    'Last pouch does not match the lot. The run can close; the quality person sees it.',
  'pack.fill.endTitle': 'Leftover and spillage',
  'pack.fill.sackType': 'Sack type',
  'pack.fill.leftover': 'Left in hopper (kg)',
  'pack.fill.leftoverTag': 'Leftover sack tag',
  'pack.fill.spillage': 'Spillage (kg)',
  'pack.fill.spillageTag': 'Spillage sack tag',
  'pack.fill.zeroIfNone': 'What the scale shows with the sack; type 0 if none',
  'pack.fill.dayOverTitle': 'The pack date is over',
  'pack.fill.dayOverBody': 'Finish filling now. A new run and lot are needed for the rest.',
  'pack.fill.heldFinish': 'The batch is on hold: finish with what was filled.',
  'pack.fill.sacksLeft':
    '{n} issued {n:sack is|sacks are} not in yet: weigh {n:it|them} in before Filling finished.',
  'pack.fill.finished': 'Filling finished',

  // close
  'pack.close.label': 'Label version',
  'pack.close.lotCode': 'Pack lot',
  'pack.close.lastMatches': 'Last pouch matches the label',
  'pack.close.lastNoMatch':
    'The run closes with a problem; the lot cannot be released until the quality person resolves it.',
  'pack.close.pouchCheckGap':
    'A first or last pouch check is missing or did not match. The quality person will see it.',
  'pack.close.counts': 'Codes',
  'pack.close.applied': 'Pouches applied (good)',
  'pack.close.printed': 'Codes printed (coder counter)',
  'pack.close.counterPhoto': 'Counter photo',
  'pack.close.spoiled': 'Spoiled',
  'pack.close.spoiledHint': 'Printed on rejected or misprinted pouches ({n} rejected today)',
  'pack.close.destroyed': 'Destroyed',
  'pack.close.destroyedHint': 'Printed but never made into a pouch: test prints, end of roll',
  'pack.close.reconciliation': 'Reconciliation',
  'pack.close.addsUp': 'Adds up',
  'pack.close.gap': 'Gap of {n}',
  'pack.close.recount':
    'Recount the codes. If it still does not add up, the run closes and the lot waits for the quality person.',
  'pack.close.recounted': 'Recounted, still a gap',
  'pack.close.weightIn': 'Kilos in',
  'pack.close.leftover': 'Leftover',
  'pack.close.spillage': 'Spillage',
  'pack.close.balanceAfterSync': 'The weight balance is shown once the close has synced.',
  'pack.close.done': 'Run closed. Stack the cartons in the quarantine area.',
  'pack.close.backToFill': 'Back to filling',
  'pack.closed.waitingTitle': 'Waiting for release',
  'pack.closed.waitingBody':
    'Print carton labels at the hall desk and keep the cartons in the quarantine area.',
  'pack.closed.released': 'Released: the pouches can be dispatched.',
  'pack.closed.cartons': 'Cartons',
  'pack.closed.balance': 'Weight balance',
  'pack.closed.packed': 'Packed',
  'pack.closed.unaccounted': 'Unaccounted',

  // dispatch
  'pack.dispatch.title': 'Dispatch',
  'pack.dispatch.hint': 'Send released pouches to a buyer',
  'pack.dispatch.needsNetwork': 'A dispatch needs network: the vehicle waits until it is saved.',
  'pack.dispatch.buyer': 'Customer',
  'pack.dispatch.invoice': 'Invoice or challan number',
  'pack.dispatch.vehicle': 'Vehicle number',
  'pack.dispatch.driver': 'Driver name',
  'pack.dispatch.driverPhone': 'Driver phone',
  'pack.dispatch.phoneBad': '10 digits',
  'pack.dispatch.clean': 'Vehicle bed empty and clean, no chemicals',
  'pack.dispatch.notClean': 'Clean the vehicle bed first. The dispatch cannot be saved.',
  'pack.dispatch.scan': 'Scan a carton label',
  'pack.dispatch.notCarton': 'Not a carton or pouch label',
  'pack.dispatch.unknownLot': 'Pack lot not at this hall',
  'pack.dispatch.already': 'This lot is already on the trip',
  'pack.dispatch.refusal.NOT_RELEASED': 'Not released yet',
  'pack.dispatch.refusal.ON_HOLD': 'Lot on hold',
  'pack.dispatch.refusal.TOO_MANY': 'Only {n} pouches left at the hall',
  'pack.dispatch.refusal.NONE_LEFT': 'No pouches left at the hall',
  'pack.dispatch.lots': 'Pack lots · {n}',
  'pack.dispatch.pouches': 'Pouches',
  'pack.dispatch.total': 'Total {n} {n:pouch|pouches}',
  'pack.dispatch.button': 'Dispatch',
  'pack.dispatch.done': 'Trip {code} saved',
  'pack.dispatch.doneTitle': 'Trip {code} saved',
  'pack.dispatch.doneBody':
    '{n} {n:pouch|pouches} on the way. Hand the dispatch note and the invoice to the driver.',
  'pack.dispatch.failed': 'The dispatch was not saved',
  'pack.dispatch.printNote': 'Print dispatch note',
  'pack.dispatch.another': 'New trip',

  // empty held pouches
  'pack.delabel.title': 'Empty held pouches',
  'pack.delabel.list': 'Pouches to empty',
  'pack.delabel.badge': 'Ordinary',
  'pack.delabel.pouches': '{n} {n:pouch|pouches}',
  'pack.delabel.toEmpty': 'Pouches to empty or destroy',
  'pack.delabel.rule':
    'Our label is never reused: count the film and destroy it. Every new sack gets a red tie.',
  'pack.delabel.newSack': 'New ordinary sack',
  'pack.delabel.sackSaved': 'Sack saved',
  'pack.delabel.counts': 'Counts',
  'pack.delabel.emptied': 'Pouches emptied',
  'pack.delabel.destroyedWhole': 'Pouches destroyed whole',
  'pack.delabel.film': 'Film destroyed',
  'pack.delabel.filmHint': 'One film per pouch emptied',
  'pack.delabel.countGap': '{n} counted of {m} pouches',
  'pack.delabel.done': 'Closed. The office records the disposal.',
  'pack.delabel.closed': 'This run is closed.',
  // ---- Seva Mandir V1 (features/pack/v1) ----
  'pack.v1.lang': 'en',
  'pack.v1.help':
    'Each job has its own screen. Do them in order: clean, start, sacks, first pouch, fill, leftover, counter. Stuck? Call the supervisor.',
  'pack.v1.needsNet': 'Needs network',
  'pack.v1.next': 'Next',
  'pack.v1.ok': 'OK',
  'pack.v1.save': 'Save',
  'pack.v1.done': 'Done',
  'pack.v1.home': 'Home',
  'pack.v1.scan': 'Scan',
  'pack.v1.gotIt': 'Got it',
  'pack.v1.supervisor': 'Supervisor',
  'pack.v1.listen': 'Listen',
  'pack.v1.todo': 'Now do',
  'pack.v1.groundnut': 'Groundnut kernels',
  'pack.v1.sizeG': '{g} g',
  'pack.v1.sizeKg': '{kg} kg',
  'pack.v1.line': 'Line {line}',
  'pack.v1.lineOne': 'Line 1',
  'pack.v1.lotTail': 'Lot …{tail}',
  'pack.v1.lotCode': 'Lot {code}',
  'pack.v1.batchTail': 'Batch …{tail}',
  'pack.v1.farmerNo': 'Farmer no. {no}',
  'pack.v1.goodLot': 'Good stock · lot …{tail}',
  'pack.v1.pouches': '{count} {count:pouch|pouches}',
  'pack.v1.pouchUnit': 'pouches',
  'pack.v1.cartons': '{count} {count:carton|cartons}',
  'pack.v1.home.title': 'Today: packing',
  'pack.v1.home.none': 'No run given yet',
  'pack.v1.home.noneLine': 'The office gives the run (product and batch). Then it shows here.',
  'pack.v1.home.refresh': 'Check again',
  'pack.v1.home.size': '{size} · {pouches} pouches',
  'pack.v1.home.batch': '{sacks} {sacks:sack|sacks} · {kg} kg',
  'pack.v1.home.batchOnly': 'Brand batch',
  'pack.v1.home.job1': 'Clean line',
  'pack.v1.home.job1Line': 'Hopper photo',
  'pack.v1.home.job2': 'Start packing',
  'pack.v1.home.job2Line': 'Lot code, dates',
  'pack.v1.home.held': 'Batch on hold: do not start',
  'pack.v1.home.heldNote': 'This batch is **on hold**. Do not start. Ask the supervisor.',
  'pack.v1.home.noLabel': 'No approved label: tell the office',
  'pack.v1.home.others': '{count} more {count:run|runs} after this one',
  'pack.v1.clean.title': 'Clean the line',
  'pack.v1.clean.cta': 'Clean the line',
  'pack.v1.clean.lastCrop': 'Last run **{crop}**: **full clean**',
  'pack.v1.clean.full': 'Last run was another crop: **full clean**',
  'pack.v1.clean.photo': 'Empty hopper',
  'pack.v1.clean.take': 'Photo',
  'pack.v1.clean.again': 'Again',
  'pack.v1.clean.taken': 'Taken',
  'pack.v1.clean.hint': 'Nothing of the last run left: hopper, belt, filler empty.',
  'pack.v1.clean.wait': 'Take the hopper photo',
  'pack.v1.clean.done': 'Cleaning done',
  'pack.v1.clean.doneFull': 'Full clean done',
  'pack.v1.start.cta': 'Start packing',
  'pack.v1.start.title': 'Start packing?',
  'pack.v1.start.line': '{line} · {sacks} sacks · {pouches} pouches',
  'pack.v1.start.cleaned': 'Cleaned · hopper photo',
  'pack.v1.start.lot': 'LOT {code}',
  'pack.v1.start.dates': 'PKD {pkd} · BB {bb}',
  'pack.v1.start.qr': 'id.uncompromised.in / lot',
  'pack.v1.start.locked': 'Lot code, dates, QR **never change again**',
  'pack.v1.start.yes': 'Yes, start',
  'pack.v1.start.failed': 'Could not start',
  'pack.v1.coder.title': 'Key the coder',
  'pack.v1.coder.started': 'Packing started · {time}',
  'pack.v1.coder.lot': 'Lot · LOT',
  'pack.v1.coder.packed': 'Packed · PKD',
  'pack.v1.coder.bb': 'Use by · BB',
  'pack.v1.coder.qr': 'QR',
  'pack.v1.coder.sheet': 'Coder sheet',
  'pack.v1.coder.done': 'Keyed in',
  'pack.v1.run.title': 'Packing on',
  'pack.v1.run.about': 'About {pouches} pouches',
  'pack.v1.run.job1': 'Sacks in',
  'pack.v1.run.job2': 'First pouch',
  'pack.v1.run.job3': 'Fill pouches',
  'pack.v1.run.job4': 'Leftover',
  'pack.v1.run.then': 'Then: close run',
  'pack.v1.run.thenLine': 'Counter number',
  'pack.v1.run.missing': 'Run not on this phone',
  'pack.v1.run.missingBody': 'Go back and check again with network.',
  'pack.v1.sack.title': 'Scan sack',
  'pack.v1.sack.band': 'Good stock · sack {n}/{total} · {kg} kg',
  'pack.v1.sack.saved': 'Sack {n} · {kg} kg',
  'pack.v1.sack.hint': 'Sack tag',
  'pack.v1.sack.then': 'After the scan, tip it into the **hopper**',
  'pack.v1.sack.wait': 'Scan the first sack',
  'pack.v1.sack.allIn': 'All sacks in',
  'pack.v1.sack.notSack': 'Not a sack tag: scan the sack',
  'pack.v1.wrong.title': 'Sack of another batch',
  'pack.v1.wrong.s1': 'Do **not** tip into the hopper',
  'pack.v1.wrong.s2': 'Return to the **store keeper**',
  'pack.v1.wrong.s3': 'Tipped in? Call the **supervisor** now',
  'pack.v1.first.title': 'First pouch',
  'pack.v1.first.print': 'Print the **first pouch** from the coder',
  'pack.v1.first.hint': 'Pouch QR',
  'pack.v1.first.type': 'Lot number on the pouch',
  'pack.v1.first.wont': 'QR won’t scan',
  'pack.v1.first.wait': 'Scan the QR',
  'pack.v1.first.again': 'Scan again',
  'pack.v1.first.sackTag': 'This is a sack tag: scan the pouch QR',
  'pack.v1.first.noSack': 'No sack in yet: put a sack in first',
  'pack.v1.wont.title': 'QR not scanning',
  'pack.v1.wont.why': 'Bad print',
  'pack.v1.wont.s1': 'Stop the **coder**',
  'pack.v1.wont.s2': 'Ask the supervisor to **fix the print**',
  'pack.v1.wont.s3': 'Print a new pouch, **scan** it',
  'pack.v1.wont.cut': 'Bad pouch: cut it, kernels back **into the hopper**',
  'pack.v1.mismatch.title': 'QR not of this lot',
  'pack.v1.mismatch.s2': 'Key the lot **again** from the coder sheet',
  'pack.v1.mismatch.got': 'On pouch',
  'pack.v1.mismatch.want': 'Needed',
  'pack.v1.mismatch.cut': 'Wrong pouch: cut it, kernels back **into the hopper**',
  'pack.v1.fill.title': 'Fill pouches',
  'pack.v1.fill.filled': 'Pouches filled',
  'pack.v1.fill.carton': '+1 carton',
  'pack.v1.fill.saved': 'Carton {cartons} · {pouches} pouches',
  'pack.v1.fill.moreSacks': 'More sacks',
  'pack.v1.fill.type': 'Type count',
  'pack.v1.fill.typeTitle': 'How many pouches filled?',
  'pack.v1.fill.undo': 'Undo last',
  'pack.v1.fill.wait': 'Count the pouches',
  'pack.v1.fill.done': 'Filling done',
  'pack.v1.left.title': 'Leftover',
  'pack.v1.left.band': 'Good stock · new sack',
  'pack.v1.left.label': 'How much left? Else 0',
  'pack.v1.left.speak': '{kg} kilo',
  'pack.v1.left.tag': 'New sack tag',
  'pack.v1.left.wait': 'Type the weight, or 0',
  'pack.v1.left.needTag': 'Scan the new sack’s tag',
  'pack.v1.left.noSack': 'No sack type on this phone',
  'pack.v1.left.saved': 'Leftover sack · {kg} kg',
  'pack.v1.left.none': 'None',
  'pack.v1.left.noneSaved': 'No leftover',
  'pack.v1.counter.title': 'Coder counter',
  'pack.v1.counter.ask': 'Which number is on the counter?',
  'pack.v1.counter.label': 'Counter',
  'pack.v1.counter.pouches': '{count} pouches filled · {cartons} cartons',
  'pack.v1.counter.spoiled': 'Spoiled codes',
  'pack.v1.counter.spoiledHint': 'Printed but not on a good pouch (jam, misprint, torn)',
  'pack.v1.counter.wait': 'Type the counter number',
  'pack.v1.close.cta': 'Close run',
  'pack.v1.close.title': 'Close run?',
  'pack.v1.close.locked': 'After the close **nothing can be added**',
  'pack.v1.close.yes': 'Yes, close',
  'pack.v1.close.overfill':
    'More out than in: {out} kg of pouches and leftover from {in} kg of sacks. Check the pouch count.',
  'pack.v1.close.fixCount': 'Correct the pouch count',
  'pack.v1.closed.title': 'Run closed',
  'pack.v1.closed.line': '{pouches} pouches · {cartons} cartons',
  'pack.v1.closed.s1': 'Keep the cartons apart **in the hall**',
  'pack.v1.closed.s2': 'Send only after the office’s **release**',
  'pack.v1.stop.title': 'Wait: batch held',
  'pack.v1.stop.big': 'Stop filling now',
  'pack.v1.stop.why': 'Batch …{tail} · {reason}',
  'pack.v1.stop.lab': 'lab check',
  'pack.v1.stop.office': 'held by the office',
  'pack.v1.stop.s1': 'Stop the **coder**',
  'pack.v1.stop.s2': 'Count the filled pouches, **close the run**',
  'pack.v1.stop.s3': 'Cartons to the **held goods** place',
  'pack.v1.hall.title': 'Packing hall',
  'pack.v1.hall.atHall': 'Pouches in the hall',
  'pack.v1.hall.released': 'Released',
  'pack.v1.hall.waiting': 'Release due',
  'pack.v1.hall.held': 'Held',
  'pack.v1.hall.canGo': 'Can be sent',
  'pack.v1.hall.noneReady': 'No released lot yet',
  'pack.v1.hall.noneReadyLine': 'Lots go only after the office releases them.',
  'pack.v1.hall.dispatch': 'Dispatch',
  'pack.v1.hall.receive': 'Truck came? Unload',
  'pack.v1.hall.receiveLine': 'Batches from the processing site',
  'pack.v1.buyer.title': 'Who is it for?',
  'pack.v1.buyer.wait': 'Pick the customer',
  'pack.v1.buyer.none': 'No customer on this phone. Ask the office.',
  'pack.v1.invoice.title': 'Invoice number',
  'pack.v1.invoice.label': 'Invoice number (last 4)',
  'pack.v1.invoice.wait': 'Type the invoice number',
  'pack.v1.lots.title': 'How many pouches?',
  'pack.v1.lots.left': '{count} in the hall',
  'pack.v1.lots.wait': 'Type pouches for a lot',
  'pack.v1.lots.over': 'Lot …{tail}: only {left} in the hall',
  'pack.v1.trip.title': 'Send the goods?',
  'pack.v1.trip.line': 'Invoice {invoice} · {count} {count:pouch|pouches}',
  'pack.v1.trip.locked': 'After sending, pouches **cannot be removed or added**',
  'pack.v1.trip.yes': 'Yes, send',
  'pack.v1.sent.title': 'Goods sent',
  'pack.v1.sent.line': '{buyer} · invoice {invoice}',
  'pack.v1.sent.s1': 'Send the **invoice** with the goods',
  'pack.v1.sent.failed': 'Not sent',
  'pack.v1.error.ALLERGEN_CLEAN_MISSING':
    'Last run was another crop: do the full clean, take a new photo',
  'pack.v1.error.SCALE_CHECK_FAILED': 'The server wants a scale check: call the office',
  'pack.v1.error.LINE_BUSY': 'Another run is open on this line',
  'pack.v1.error.RUN_ALREADY_STARTED': 'This run has already started',
  'pack.v1.error.LABEL_VERSION_MISMATCH': 'Label not approved for this hall: tell the office',
  'pack.v1.error.PREMISES_LICENCE_MISSING': 'Hall FSSAI licence missing: tell the office',
  'pack.v1.error.BATCH_NOT_PACKABLE': 'Batch cannot be packed now: ask the office',
  'pack.v1.error.CLEANOUT_MISSING': 'Hopper photo missing',
  'pack.v1.error.NOT_A_BUYER': 'Not a registered customer',
  'pack.v1.error.LOT_NOT_RELEASED': 'A lot is not released or is held',
  'pack.v1.error.OVER_DISPATCHED': 'More pouches than left in the hall',
  'pack.v1.error.UNKNOWN_PACK_LOT': 'Lot not found',
  'pack.v1.error.VEHICLE_NOT_CLEAN': 'The server wants a vehicle check: call the office',
} as const

export type PackMessageKey = keyof typeof packEn
